import React from 'react'

import { Row, Typography } from 'antd'

const { Text } = Typography

export const FormConfirmation = () => {
  return (
    <div style={{ padding: '50px', textAlign: 'center' }}>
      <Row style={{ marginBottom: '30px' }}>
        <img
          style={{ width: '200px' }}
          src='https://gcmgames-static.s3.amazonaws.com/img/logo.png'
          alt='GCM Games'
        />
      </Row>

      <Text style={{ fontSize: 25 }}>
        Muito obrigado por responder nossas perguntas, nossa equipe entrará em
        contato em breve!
      </Text>
    </div>
  )
}
